import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Row, Col, Input, Select, Drawer, Switch } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { LAPI_URL, MEDIA_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'
// import userRights from "../../components/_utils/userRights";

import { RightsWrapper } from '../../../components/_utils/utils'
import PDFFileView from '../../../components/DocumentViews/PDFFileView'
const TabPane = Tabs.TabPane
const Option = Select.Option;
let invoiceCounts = [0, 1, 2, 3, 4, 5, 6, 7, 8];


@Form.create()
class ImportCommDrawer extends React.Component {
  state = {
    visible: true
  }


  onClose = () => {
    setTimeout(() => {
      this.props.onClose();
    }, 50)
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let { form, channelPartnerId } = this.props;
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      let response = await Request.importUniversitiesComm(values);
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: response.message
        })
      }
      this.onClose();
    })
  }


  render() {
    let { visible } = this.state;
    let { form: { getFieldDecorator } } = this.props;
    let inputTypes = {
      fields: [
        {
          label: 'Upload Excel',
          key: 'excelFile',
          type: 'file'
        }
      ]
    }
    return (
      <Drawer
        title={"Import University Commissions "}
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={500}
        visible={visible}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit}>
            <GetAllFormFields inputSchema={inputTypes} apiurl={LAPI_URL} getFieldDecorator={getFieldDecorator} />
            <Button
              type=""
              htmlType="submit"
              style={{
                marginBottom: 10,
                marginLeft: '33%',
                backgroundColor: 'green',
                color: 'white'
              }}
              loading={this.props.loading}>
              SAVE
            </Button>
          </Form>
        </Card>
      </Drawer>
    )
  }
}



@Form.create()
class AllUniversityCommissions extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    bonusAny: '',
    universities: [],
    levelOptions: [],
    totalStudents: '',
    minimumStudents: '',
    maximumStudents: '',
    bonusType: '',
    commissionType: '',
    bonus: '',
    bonusDetails: [],
    bonusIndex: null,
    fullAgreement: [],
    commmissionPage: [],
    ext: null,
    linkUrl: null,
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      let data = await Request.getCommissionUniversities({
        ...params,
        regExFilters: [
          'universityInstitutionName'
        ]
      });
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  loadLevels = async () => {
    let params = { sortField: 'levelName', sortOrder: 'ascend' }
    Request.loadSimpleLevels({ ...params })
      .then(resp => {
        let temp = [{ display: '---Select All---', id: 'all' }];
        resp.data = resp.data.reduce((el, vv) => {
          temp.push({ _id: vv._id, display: vv.levelName })
          return temp
        }, [])
        this.setState({ levelOptions: resp.data })
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        values.bonusAny = (values.bonusAny ? values.bonusAny : 'No');
        values.bonusDetails = this.state.bonusDetails;
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateUniversityCommission(values)
        } else {
          x = await Request.addUniversityCommission(values)
        }
        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Commission Updated Successfully`
              : 'Commission Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteCommission = async data => {
    this.setState({ loading: true })
    await Request.deleteCommission(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setCommissionData(commissionId) {
    if (commissionId) {
      Request.getCommissionById({ id: commissionId }).then(
        ({ doc, error, message }) => {
          if (!error) {
            this.setState({
              id: doc._id,
              activeTab: '1',
            })
            this.setState({ bonusAny: doc.bonusAny, bonusDetails: doc.bonusDetails });

            this.props.form.setFieldsValue({
              universityId: doc.universityId,
              commissionFromUniversity: doc.commissionFromUniversity,
              paymentTimeline: doc.paymentTimeline,
              invoicePerYear: doc.invoicePerYear,
              noOfInvoice: doc.noOfInvoice,
              courseLevelId: doc.courseLevelId,
              commissionTypeFrom: doc.commissionTypeFrom,
              bonusAny: doc.bonusAny
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  addBonusCommission = () => {
    let { totalStudents, minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusDetails } = this.state;
    if (!minimumStudents || !maximumStudents) {
      notification.error({
        message: 'Min - Max Students Required'
      })
      return false;
    } else if (!bonusType) {
      notification.error({
        message: 'Bonus Type is required'
      })
      return false;
    } else if (!commissionType) {
      notification.error({
        message: 'Commission Type is required'
      })
      return false;
    }
    bonusDetails.push({
      minimumStudents,
      maximumStudents,
      bonusType,
      commissionType,
      bonus
    })
    this.setState({
      bonusDetails: bonusDetails,
      bonusIndex: null,
      minimumStudents: null,
      maximumStudents: null,
      bonusType: null,
      commissionType: null,
      bonus: null
    });
  }

  exportExcel = async () => {
    let { exportParams } = this.state
    let x = await Request.exportUniversityCommission(exportParams)
    if (!x.error) {
      window.open(x.url)
    }

    // let x = await Request.exportSalarySheet()
    // // let x = await Request.exportUsersToExcel({
    // //      regExFilters: ['name'
    // //     ]
    // // })
    // if (!x.error) {
    //   window.open(x.url)
    // }
  }

  removeBonus = (index) => {
    let { bonusDetails } = this.state;
    if (bonusDetails[index] !== undefined) {
      bonusDetails.splice(index, 1);
    }
    this.setState({
      bonusDetails: bonusDetails
    });
  }
  editBonus = (index, bonusDetail) => {
    this.setState({
      bonusIndex: index,
      minimumStudents: bonusDetail.minimumStudents,
      maximumStudents: bonusDetail.maximumStudents,
      bonusType: bonusDetail.bonusType,
      commissionType: bonusDetail.commissionType,
      bonus: bonusDetail.bonus
    });
  }


  updateBonusCommission = () => {
    let { minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusIndex, bonusDetails } = this.state;
    if (!minimumStudents || !maximumStudents) {
      notification.error({
        message: 'Min - Max Students is required'
      })
      return false;
    } else if (!bonusType) {
      notification.error({
        message: 'Bonus Type is required'
      })
      return false;
    } else if (!commissionType) {
      notification.error({
        message: 'Commission Type is required'
      })
      return false;
      // } else if(!bonus) {
      //   notification.error({
      //     message: 'Bonus is required'
      //   })
      //   return false;
    }
    if (bonusDetails[bonusIndex] !== undefined) {
      bonusDetails[bonusIndex] = {
        minimumStudents,
        maximumStudents,
        bonusType,
        commissionType,
        bonus
      };
    }
    this.setState({
      bonusDetails: bonusDetails,
      bonusIndex: null,
      totalStudents: null,
      minimumStudents: null,
      maximumStudents: null,
      bonusType: null,
      commissionType: null,
      bonus: null
    });
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  updateActiveStatus = async (recordId, checked) => {
    let payload = {
      _id: recordId,
      activeStatus: checked
    }
    let response = await Request.updateUniversityCommissionActiveStatus(payload);
    if (response.success) {
      notification.success({ message: response.message })
    } else {
      notification.error({ message: response.message });
    }
    this.table.current.reload();
  }


  showCommImport = () => {
    this.setState({ showImportDrawer: true });
  }

  closeCommImport = () => {
    this.setState({ showImportDrawer: false })
  }
  loadUniversity = async () => {
    Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
      .then(resp => {
        resp.arr = resp.arr.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.universityInstitutionName })
          return temp
        }, [])

        this.setState({ 'universities': resp.arr });
        this.refreshFxn()
      })
      .catch(err => {
        console.log(err)
      })
  }

  componentWillMount() {

  }

  checkUrlExt = (url) => {
    return url.split(/[#?]/)[0].split('.').pop().trim();
  }

  closeDocument = () => {
    this.setState({ ext: null, linkUrl: null });
  }


  viewPDF = (file) => {
    if (file && file.length > 0) {
      let linkUrl = MEDIA_URL + file[0].url;
      let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
      if (this.checkUrlExt(linkUrl)) {
        this.setState({ ext: ext, linkUrl: linkUrl });
      } else {
        notification.warning({
          message: 'Agreement not exists!!!.'
        })
      }
    }
  }

  async componentDidMount() {
    await this.loadUniversity();
    await this.loadLevels();
  }

  getUniversityDetail = async (universityId) => {
    let { doc } = await Request.getUniversity(universityId);

    this.setState({ fullAgreement: doc && doc.paymentUpload ? doc.paymentUpload : [], commmissionPage: doc && doc.paymentUploadCommissionPage ? doc.paymentUploadCommissionPage : [] })
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const { dispatch } = this.props
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { typeList, bonusAny, universities, id, levelOptions, bonusDetails, bonusIndex, showCommImport, ext, linkUrl, fullAgreement, commmissionPage } = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Select University ',
          key: 'universityId',
          required: true,
          type: 'select',
          showSearch: true,
          disabled: false,
          options: universities,
          onChange: v => {
            this.getUniversityDetail(v)
            this.props.form.setFieldsValue({
              universityId: v
            })
          }
        },
        {
          label: 'Course Level',
          key: 'courseLevelId',
          type: 'select',
          required: true,
          showSearch: true,
          mode: 'multiple',
          disabled: false,
          options: levelOptions,
          onChange: v => {
            let val = v ? v : [];
            if (v && v.length && v.includes("all")) {
              if (v.length === levelOptions.length) {
                val = [];
              } else {
                val = levelOptions.slice(1).map(levelOption => levelOption._id);
              }
            }
            this.props.form.setFieldsValue({
              courseLevelId: val
            })
          }
        },
        {
          label: 'No Of Invoices',
          key: 'noOfInvoice',
          type: 'select',
          required: true,
          disabled: false,
          options: invoiceCounts,
          onChange: v => {
            this.props.form.setFieldsValue({
              noOfInvoice: v
            })
          }
        },
        {
          label: 'Invoice Per Year',
          key: 'invoicePerYear',
          type: 'select',
          required: true,
          disabled: false,
          options: invoiceCounts,
          onChange: v => {
            this.props.form.setFieldsValue({
              invoicePerYear: v
            })
          }
        },
        {
          label: 'Commission Type',
          key: 'commissionTypeFrom',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Flat', 'Percentage'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              commissionTypeFrom: v
            })
          }
        },
        {
          label: 'Commission Amount / %',
          key: 'commissionFromUniversity',
          required: true
        },
        {
          label: 'Payment Due Post Submission of Invoice (Days)',
          key: 'paymentTimeline',
          required: true,
          type: 'number'
        },
        {
          label: 'Bonus If any',
          key: 'bonusAny',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Yes', 'No'
          ],
          onChange: v => {
            this.setState({ bonusAny: v });
            this.props.form.setFieldsValue({
              bonusAny: v
            })
          }
        }
      ]
    };



    const columns = [
      {
        title: 'University Name',
        key: 'universityInstitutionName',
        width: 250,
        dataIndex: 'universityInstitutionName',
        searchTextName: "University Name",

      },
      {
        title: 'Commission',
        key: 'commissionFromUniversity',
      },
      {
        title: 'Country',
        key: 'universityCountryName',
        dataIndex: 'universityId.universityCountryName',
        searchTextName: 'Country Name'
      },
      {
        title: 'Total No Of Invoices / Invoice Per Year',
        key: 'noOfInvoice',
        render: (text, record) => (
          <div>{record.noOfInvoice}/{record.invoicePerYear}</div>
        )
      },
      {
        title: 'Payment Due (Days)',
        key: 'paymentTimeline',
      },
      {
        title: 'Commission Type',
        key: 'commissionTypeFrom',
        filters: [{ text: 'Flat', value: 'Flat' }, { text: 'Percentage', value: 'Percentage' }],
      },
      {
        title: 'Status',
        key: 'status',
        filters: [{ text: 'Pending', value: 'Pending' }, { text: 'Active', value: 'Active' }],
      },
      {
        title: 'Active Status',
        key: 'activeStatus',
        dataIndex: 'activeStatus',
        render: (text, record) => {
          return (
            <Switch
              checked={record.activeStatus}
              onChange={(checked) => this.updateActiveStatus(record._id, checked)}
            />
          );
        }
      },

      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'financeUniversityCommission.edit'}>
              <Tooltip title="Edit Commission">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setCommissionData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'financeUniversityCommission.delete'}>
              <Tooltip title="Delete Commission">
                <Popconfirm
                  title="Are you sure delete this Commission?"
                  onConfirm={() => {
                    this.deleteCommission({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` University Wise Commissions `}>
        {
          this.state.showImportDrawer ?
            <ImportCommDrawer onClose={this.closeCommImport} />
            : null
        }

        {
          ext != null && linkUrl != null ?
            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
            : null
        }
        <Card bordered={true}>
          <Row gutter={16}>
            <Col span={5}>
              <div style={{ textAlign: 'right', marginTop: '15px' }}>
                <Button type={'primary'}
                  loading={this.state.exportLoading}
                  onClick={() => {
                    this.exportExcel()
                  }}>Export University Commission</Button>
                {/* {
                  userRights.checkRights("StaffOverallExcelExport.view") ?
                    
                    : null
                } */}
              </div>
            </Col>
            <Col span={5}>
              <div style={{ textAlign: 'right', marginTop: '15px' }}>
                <Button type={'primary'}
                  loading={this.state.exportLoading}
                  onClick={this.showCommImport}>Import University Commission</Button>
              </div>
            </Col>


          </Row>
        </Card>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Commissions`} key={0}>
              <h2>{`Commissions : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 1300 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Commission'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />

                <Row>
                  <Col span={12}></Col>

                  <Col span={12}>
                    <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                      {fullAgreement && fullAgreement.length > 0 ? (
                        <Button
                          type="primary"
                          onClick={() => this.viewPDF(fullAgreement)}
                        >
                          View Full Agreement
                        </Button>
                      ) : null}

                      {commmissionPage && commmissionPage.length > 0 ? (
                        <Button onClick={() => this.viewPDF(commmissionPage)}>
                          View Agreement Commission
                        </Button>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                {
                  bonusAny == 'Yes' ?
                    <div>
                      <Card title="Bonus Details">
                        <div>
                          <Row>
                            <Col span={3}>
                              <label>Min Students</label>
                              <Input type={'number'}
                                placeholder={"Minimum"}
                                value={this.state.minimumStudents}
                                onChange={(ei) => {
                                  this.setState({ minimumStudents: ei.target.value });
                                }} />
                              {/* <label>Total Students</label>
                              <Input
                                type={'number'}
                                placeholder={"Total Students"}
                                value={this.state.totalStudents}
                                onChange={(ei) => {
                                  this.setState({ totalStudents: ei.target.value });
                                }}
                              /> */}
                            </Col>
                            <Col span={3}>
                              <label>Max Students</label>
                              <Input type={'number'}
                                placeholder={"Minimum"}
                                value={this.state.maximumStudents}
                                onChange={(ei) => {
                                  this.setState({ maximumStudents: ei.target.value });
                                }} />
                              {/* <label>Total Students</label>
                              <Input
                                type={'number'}
                                placeholder={"Total Students"}
                                value={this.state.totalStudents}
                                onChange={(ei) => {
                                  this.setState({ totalStudents: ei.target.value });
                                }}
                              /> */}
                            </Col>
                            <Col span={5}>
                              <label>Bonus Type</label>
                              <Select
                                placeholder="Select Bonus Type"
                                showSearch={true}
                                value={
                                  this.state.bonusType
                                }
                                onChange={(ei) => {
                                  this.setState({
                                    bonusType: ei
                                  });
                                }}
                              >
                                <Option value={'Per Student'}> Per Student </Option>
                                <Option value={'Total Student'}> Total Student </Option>
                              </Select>
                            </Col>
                            <Col span={5}>
                              <label>Commission Type</label>
                              <Select
                                placeholder="Select Commission Type"
                                showSearch={true}
                                value={
                                  this.state.commissionType
                                }
                                onChange={(ei) => {
                                  this.setState({
                                    commissionType: ei
                                  });
                                }}
                              >
                                <Option value={'flat'}> Flat </Option>
                                <Option value={'percantage'}> Percantage </Option>
                              </Select>
                            </Col>
                            <Col span={5}>
                              <label>Commission</label>
                              <Input
                                type={'Bonus'}
                                placeholder={"Bonus"}
                                value={this.state.bonus}
                                onChange={(ei) => {
                                  this.setState({ bonus: ei.target.value });
                                }}
                              />
                            </Col>
                            <Col span={2}>
                              <label>&nbsp;&nbsp;&nbsp;</label>
                              {
                                bonusIndex != null ?
                                  <Button
                                    type="primary"
                                    style={{ marginBottom: 10, marginLeft: '1%' }}
                                    loading={this.props.loading}
                                    onClick={() => {
                                      this.updateBonusCommission()
                                    }}>
                                    Update
                                  </Button>
                                  :
                                  <Button
                                    type="primary"
                                    style={{ marginBottom: 10, marginLeft: '1%' }}
                                    loading={this.props.loading}
                                    onClick={() => {
                                      this.addBonusCommission()
                                    }}>
                                    Add
                                  </Button>
                              }

                            </Col>
                          </Row>
                          <Row>
                            <Card title="Bonus List">
                              <table className="table-bonus-list">
                                <thead>
                                  <tr>
                                    {/* <th>Total Students</th> */}
                                    <th>Min - Max Students</th>
                                    {/* <th>Maximum</th> */}
                                    <th>Bonus Type</th>
                                    <th>Commission Type</th>
                                    <th>Bonus</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    bonusDetails && bonusDetails.map((bonusDetail, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>{`${bonusDetail.minimumStudents} - ${bonusDetail.maximumStudents}`}</td>
                                          {/* <td>{bonusDetail.totalStudents}</td> */}
                                          {/* <td>{bonusDetail.minimum}</td>
                                          <td>{bonusDetail.maximum}</td> */}
                                          <td>{bonusDetail.bonusType}</td>
                                          <td>{bonusDetail.commissionType}</td>
                                          <td>{bonusDetail.bonus}</td>
                                          <td><a onClick={() => this.editBonus(index, bonusDetail)}>Edit</a> | <a onClick={() => this.removeBonus(index)}>Remove</a></td>
                                        </tr>
                                      )
                                    })
                                  }
                                </tbody>
                              </table>
                            </Card>
                          </Row>
                        </div>
                      </Card>
                    </div>
                    : null
                }
                {

                }
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllUniversityCommissions
